import notification from 'ant-design-vue/es/notification'

/**
 * 获取错误信息
 */
const getErrorList = (errs) => {
    if (!errs || Object.keys(errs).length === 0) {
        return null;
    }

    for (let key in errs) {
        if (!errs[key]) {
            delete errs[key]
        }
    }
    return errs;
}


/**
 * 格式化错误信息
 */
const detailFormat = (text = '') => {
    const textArr = text.split('\\n')
    return (h) => {
        return (<div> {
            textArr.map(item => (<p style="margin-bottom:0"> {item}</p>))
        } </div>)
    }
}

/**
 * 处理生成错误信息内容
 */
export const errorMsg = (err, fieldLabels) => {
    const errRes = err.response
    if (String(errRes && errRes.status).startsWith('50')) {
        return errRes.statusText ? "服务器异常：" + errRes.statusText : "服务器异常"
    } else if (errRes && errRes.status == '499') {
        return detailFormat(errRes.data.detail)
    } else if (errRes && errRes.status == '401') {
        return '授权验证失败'
    } else if (errRes && errRes.status == '403') {
        return '禁止访问'
    } else if (errRes && errRes.status == '400') {
        const errObj = errRes.data
        let errMsg = ""
        for (let key in errObj) {
            errMsg += (key || '错误') + "：" + (
                Array.isArray(errObj[key]) ? errObj[key][0] : errObj[key]
            ) + ' \n ';
        }
        return errMsg || "请求出现错误，请稍后再试";
    } else {
        if ((errRes.data || {}).detail) {
            return errRes.data.detail
        }
        return '意外错误'
    }
}

/**
 * 处理服务器错误信息
 */

export const handleErrs = (err, msg = '失败') => {
    /**
     * @paramas err: 错误对象
     * msg: 弹窗的message
     */
    // 判断是什么类型的错误
    const error = err.response || {}
    const status = error.status || ''
    const data = error.data || {}
    const errmsg = errorMsg(err, {})
    if (status === 401) {
        msg = '未经授权'
    } else if (status === 403) {
        msg = '禁止访问'
    }
    notification['error']({ message: msg, description: errmsg });

    if (status === 400) {
        const result = getErrorList({ ...data })
        return result;
    } else { }
    // if (status && status.toString().startsWith('50')) { // 服务器错误
    //     notification['error']({
    //         message: msg,
    //         description: statusTxt ? '服务器错误：' + statusTxt : '服务器错误'
    //     });
    // } else if (status === 400) {
    //     notification['error']({message: msg, description: getErrorDesc(data)});
    //     return getErrorList({
    //         ... data
    //     })
    // } else if (status === 499) {
    //     notification['error']({
    //         message: msg,
    //         description: detailFormat(data.detail)
    //     });
    // } else if ([406, 404, 429].includes(status)) {
    //     notification['error']({message: msg, description: data.detail});
    // } else {
    //     notification['error']({message: msg, description: '未知错误'});
    // }
    // console.log(error.data)
    return {};
}


// WEBPACK FOOTER //
// ./src/utils/errors.js